import { Stack, Tooltip, Typography } from "@mui/material";
import { CircleHelp } from "lucide-react";
import "./IdeaFormRegistry.scss";

export default function IdeaFormRegistry(props: { text: string; tooltipText: string }) {
	return (
		<Tooltip
			title={props.tooltipText}
			arrow
			placement="top"
			classes={{
				tooltip: "form__label__tooltip",
				arrow: "form__label__tooltip__arrow",
			}}
			className="form__label"
		>
			<Stack flexDirection={"row"}>
				<Typography>{props.text}</Typography>

				<CircleHelp />
			</Stack>
		</Tooltip>
	);
}
